import { Capacitor } from '@capacitor/core';

/** Whether the app is running inside a native Capacitor shell (iOS / Android). */
export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}

/** Returns 'ios', 'android', or 'web'. */
export function getPlatform(): 'ios' | 'android' | 'web' {
  return Capacitor.getPlatform() as 'ios' | 'android' | 'web';
}

/**
 * Whether the native Swift/Kotlin implementation of a Capacitor plugin
 * is compiled into the app. This checks `Capacitor.PluginHeaders` — the
 * list populated by native code during app startup.
 *
 * Use this instead of `isNativePlatform()` before calling plugin proxies
 * from `@aparajita/*` — their native JS wrappers create an infinite
 * delegation loop through the Capacitor proxy when native code is absent.
 */
export function hasNativePlugin(pluginName: string): boolean {
  // PluginHeaders is populated by the native bridge but isn't part
  // of the public TypeScript API, hence the cast.
  const headers: Array<{ name: string }> | undefined = (
    Capacitor as unknown as { PluginHeaders?: Array<{ name: string }> }
  ).PluginHeaders;
  return !!headers?.some((h) => h.name === pluginName);
}
